import _ from "lodash";

// 回车，换行，水平制表符，垂直制表符，退格，换页，半角空格，不间断空格
const charsToTrim = '\r\n\t\v\b\f\u0020\u00A0';

export default {
  // asterisk header progress function
  asteriskHeaderArray2Json (arrStr){
    if(arrStr){
      if(typeof arrStr == 'string') {
        // param arr type is string, use '|' split this string to array and user ':' split the array to object key
        const arr = arrStr.split('|')
        let obj = {}
        for (const k of arr) {
          obj[k.split(":")[0]] = k.split(":")[1]
        }
        return obj
      } else {
        return {}
      }
    } else {
      return {}
    } 
  },
  computeFullName(lastName, firstName) {
    return `${lastName || ''} ${firstName || ''}`.trim();
  },
  generateThumbnail(image, thumbnailWidth, thumbnailHeight) {
    console.log('utils: generateThumbnail--------------------------')
    const canvas = document.createElement('canvas');
    canvas.width = thumbnailWidth;
    canvas.height = thumbnailHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, thumbnailWidth, thumbnailHeight);
    return canvas.toDataURL('image/jpeg');
  },
  // 去除字符串两端的空白字符
  // 安全方法。参数为null或undefined时返回空字符串，并且不会改变原字符串
  trimBlankChars(str) {
    return _.trim(str, charsToTrim);
  }
}